import { useIntl } from 'react-intl';

import { phaseComing, phaseEnded, phaseOngoing } from '../../../../../Utils/Post';
import { getStepName, isImplementationStep } from '../../../../../Utils/Steps';
import { moment } from '../../../../../I18n';

export const ConsultationProgressStatuses = {
  ENDED: 'ENDED',
  IMPLEMENTATION: 'IMPLEMENTATION',
  ONGOING: 'ONGOING',
  COMING: 'COMING',
};

export const stepName = (currentStep: any, postType: any) => {
  const intl = useIntl();

  return getStepName(
    postType,
    currentStep.step_type,
    currentStep.open_to_citizen_and_contributor,
    intl,
  );
};

export const totalDays = (currentStep: any) => {
  const start = moment(currentStep.start_at);
  const end = moment(currentStep.end_at);

  return end.diff(start, 'days');
};

export const inNDays = (currentStep: any) => {
  const start = moment(currentStep.start_at);

  return moment(start).fromNow();
};

export function getConsultationProgressStatus(currentStep: any) {
  if (isImplementationStep(currentStep.step_type) && !currentStep.open_to_citizen_and_contributor) {
    return ConsultationProgressStatuses.ENDED;
  }

  if (phaseOngoing(currentStep.dates_status)) {
    if (isImplementationStep(currentStep.step_type)) {
      return ConsultationProgressStatuses.IMPLEMENTATION;
    }

    return ConsultationProgressStatuses.ONGOING;
  }

  if (phaseComing(currentStep.dates_status)) {
    return ConsultationProgressStatuses.COMING;
  }

  if (phaseEnded(currentStep.dates_status)) {
    return ConsultationProgressStatuses.ENDED;
  }

  return ConsultationProgressStatuses.ONGOING;
}
